import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, StatusPill } from "@/components/common";
import DataList from "@/components/DataList";

const URGENCY_OPTIONS = [
  { value: "all", label: "ALL" },
  { value: "critical", label: "CRITICAL" },
  { value: "high", label: "HIGH" },
  { value: "normal", label: "NORMAL" },
];

const STATUS_OPTIONS = [
  { value: "all", label: "ALL" },
  { value: "open", label: "OPEN" },
  { value: "matched", label: "MATCHED" },
  { value: "quoted", label: "QUOTED" },
  { value: "awarded", label: "AWARDED" },
];

export default function SupplierInbox() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/rfqs").then(r => setRows(r.data)); }, []);

  const columns = [
    { key: "code", label: "RFQ",
      render: r => <span className="font-mono" style={{ color: "var(--amber-400)" }}>{r.code}</span>,
      search: r => r.code },
    { key: "product_name", label: "Product",
      render: r => r.product_name, search: r => r.product_name },
    { key: "category", label: "Category",
      render: r => <span style={{ color: "var(--ink-dim)", fontSize: 13 }}>{r.category}</span>,
      search: r => r.category },
    { key: "qty", label: "Qty", render: r => `${r.quantity} ${r.unit}` },
    { key: "region", label: "Region", render: r => r.delivery_region, search: r => r.delivery_region },
    { key: "urgency", label: "Urgency",
      render: r => <span style={{ color: r.urgency === "critical" ? "var(--red)" : r.urgency === "high" ? "var(--amber-400)" : "var(--ink-dim)" }}>{r.urgency}</span> },
    { key: "status", label: "Status", render: r => <StatusPill status={r.status} /> },
    { key: "expires", label: "Expires",
      render: r => <span className="font-mono" style={{ color: "var(--ink-mute)", fontSize: 12 }}>{new Date(r.expires_at).toLocaleDateString()}</span> },
    { key: "actions", label: "",
      render: r => <Link to={`/app/rfqs/${r.id}`} data-testid={`inbox-open-${r.code}`} className="btn btn-primary" style={{ padding: "6px 14px", fontSize: 12 }}>Open / Quote</Link> },
  ];

  const filters = [
    { key: "urgency", label: "Urgency", options: URGENCY_OPTIONS,
      match: (row, value) => value === "all" || row.urgency === value },
    { key: "status", label: "Status", options: STATUS_OPTIONS,
      match: (row, value) => value === "all" || row.status === value },
  ];

  return (
    <>
      <PageHeader title="RFQ Inbox" subtitle="Anonymous RFQs matched to your category and region. Quote fast to win." />
      <DataList
        testId="supplier-inbox"
        rows={rows}
        columns={columns}
        filters={filters}
        emptyText="No matched RFQs yet."
        searchPlaceholder="Search by code, product, category, or region…"
      />
    </>
  );
}
